export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7833.a1a658c9.jpg";